/**
 * Navigation Hook - API Only (No Fallback)
 * TanStack Query integration for navigation service
 * Will show loading/error states if API is unavailable
 */

import { useQuery } from '@tanstack/react-query';
import { navigationService } from '../services/navigationService';

/**
 * Hook for fetching navigation from API only
 * No fallback - will show error state if API fails
 */
export function useSafeNavigation(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: ['navigation'],
		queryFn: () => navigationService.getNavigation(),
		staleTime: 5 * 60 * 1000, // 5 minutes
		gcTime: 10 * 60 * 1000, // 10 minutes (garbage collection time in v5)
		retry: 2, // Reduced retries since we don't want fallback
		retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
		refetchOnWindowFocus: false,
		refetchOnMount: true, // Always fetch on mount to ensure fresh data
		throwOnError: false, // Let the component handle errors
		enabled: options?.enabled
	});
}
